import React from 'react';
import './App.css';
import XRScene from './components/XRScene';
import { XRProvider, useXRStore } from './XRProvider';

// Separate component to use the XR store
const XRButtons = () => {
  const xrStore = useXRStore();
  
  return (
    <div className="button-container">
      <button className="xr-button" onClick={() => xrStore.enterVR()}>
        Enter VR
      </button>
      <button className="xr-button" onClick={() => xrStore.enterAR()}>
        Enter AR
      </button>
    </div>
  );
};

function App() {
  return (
    <XRProvider>
      <div className="App" style={{ height: '100vh', width: '100%' }}>
        <header className="App-header">
          <h1>WebXR Demo</h1>
          <p>Experience WebXR in your browser</p>          
        </header>
        <main style={{ height: '100vh', width: '100%' }}>
          <XRScene />
        </main>
      </div>
    </XRProvider>
  );
}

export default App;
